import { render, staticRenderFns } from "./COGS.vue?vue&type=template&id=83a144de"
import script from "./COGS.vue?vue&type=script&lang=js"
export * from "./COGS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports